/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/710/interface/api/cat_4403
 */
import { message } from 'ant-design-vue'
import { reactive, toRefs, ref, watch } from 'vue'
import {
  v1_portal_module_list_post,
  v1_portal_module_add_post,
  v1_portal_module_delete_post,
  v1_portal_module_update_post,
  v1_portal_module_byRoleId_post
} from 'server/modules/4403' // 工作台权限管理-添加模块

export const v1_portal_module_add_post_ = function(option) {
  const formState = reactive({
    id: null,
    moduleName: null,
    moduleCode: null,
    modulePath: null,
    type: null,
    visible: false
  })
  const rules = reactive({
    moduleName: [
      {
        required: true,
        message: '请输入模块名称'
      }
    ],
    moduleCode: [
      {
        required: formState.type !== 1,
        message: '模块Code非空'
      }
    ],
    modulePath: [
      {
        required: true,
        message: '菜单链接非空'
      }
    ]
  })
  const formRef = ref(null)

  const addmodule = async () => {
    const { success, data, retInfo } = await v1_portal_module_add_post(
      formState
    )

    if (success) {
      showModal(false)
      message.success('新增模块成功')
      option.getModuleList()
    } else {
      console.log(data)
      message.error(retInfo)
    }
  }
  const updatemodule = () => {
    v1_portal_module_update_post_(formState, () => {
      showModal(false)
      option.getModuleList()
    })
  }
  const deleteModule = id => {
    v1_portal_module_delete_post_(id, () => {
      showModal(false)
      option.getModuleList()
    })
  }
  const showModal = (visible, record) => {
    formState.visible = visible

    if (record) {
      const { id, moduleCode, moduleName, modulePath, type } = record
      Object.assign(formState, {
        id,
        moduleCode,
        moduleName,
        modulePath,
        type
      })
    } else {
      Object.assign(formState, {
        moduleName: null,
        id: null,
        moduleCode: null,
        modulePath: null,
        type: null
      })
    }
  }
  const submitmodule = () => {
    formRef.value.validate().then(() => {
      formState.id ? updatemodule() : addmodule()
    })
  }
  return {
    formRef,
    rules,
    formState,
    showModal,
    deleteModule,
    submitmodule
  }
} // 工作台权限管理-查询所有模块

export const v1_portal_module_list_post_ = function() {
  const state = reactive({
    moduleDatas: [],
    params: {
      moduleName: '',
      type: undefined
    },
    typeObj: {
      1: '菜单',
      2: '按钮'
    }
  })
  watch(
    () => state.params,
    () => {
      getModuleList()
    },
    {
      deep: true
    }
  )
  const columns = [
    {
      title: '模块ID',
      dataIndex: 'id',
      key: 'id',
      width: 80
    },
    {
      title: '模块名称',
      dataIndex: 'moduleName',
      key: 'moduleName'
    },
    {
      title: '模块Code',
      dataIndex: 'moduleCode',
      key: 'moduleCode'
    },
    {
      title: '类型',
      dataIndex: 'type',
      key: 'type'
    },
    {
      title: '菜单链接',
      dataIndex: 'modulePath',
      key: 'modulePath'
    },
    {
      title: '操作',
      key: 'action'
    }
  ]
  const getModuleList = async () => {
    const { success, data, retInfo } = await v1_portal_module_list_post(
      state.params
    )

    if (success) {
      state.moduleDatas = data.list
    } else {
      console.log(data)
      message.error(retInfo)
    }
  }

  return {
    columns,
    getModuleList,
    ...toRefs(state)
  }
} // 工作台权限管理-删除模块

export const v1_portal_module_delete_post_ = async function(id, callback) {
  const { success, data, retInfo } = await v1_portal_module_delete_post({
    id
  })
  if (success) {
    callback()
    message.success('删除成功')
  } else {
    console.log(data)
    message.error(retInfo)
  }
} // 工作台权限管理-更新模块名称

export const v1_portal_module_update_post_ = async function(params, callback) {
  const { success, data, retInfo } = await v1_portal_module_update_post(params)

  if (success) {
    callback()
    message.success('更新模块成功')
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 工作台权限管理-根据角色ID查询所有的模块
export const v1_portal_module_byRoleId_post_ = function() {
  const state = reactive({
    moduleList: []
  })
  const getModuleListByRoleId = async id => {
    const { success, data, retInfo } = await v1_portal_module_byRoleId_post({
      roleId: id
    })
    if (success) {
      state.moduleList = data
    } else {
      console.log(data)
      message.error(retInfo)
    }
  }
  return {
    getModuleListByRoleId,
    ...toRefs(state)
  }
}
